export enum TimesToastType {
  DURATION_SUCCESS_TOAST_4550 = 4550,
  DURATION_ERROR_TOAST = 4000,
  DURATION_ERROR_TOAST_LONG = 8000,
  DURATION_SUCCESS_TOAST_3750 = 3750,
  DURATION_SUCCESS_TOAST_2750 = 2750,
  DURATION_SUCCESS_TOAST_2000 = 2000,
  DURATION_SUCCESS_TOAST_1500 = 1500,
}
